<div class="w-full min-h-screen bg-white p-3 md:p-5">
  <p-toast></p-toast>
  <p-confirmDialog [style]="{width: '450px'}" acceptLabel="Sí" rejectLabel="Cancelar"></p-confirmDialog>

  <div class="mb-4">
    <h2 class="text-2xl font-bold m-0 text-900">Ubigeo</h2>
    <p class="text-500 m-0 text-sm mt-1">Países, Departamentos, Provincias y Distritos. Gestiona la ubicación para entregas.</p>
  </div>

  <div class="flex gap-2 mb-4 flex-wrap">
    <button pButton [label]="'Países'" [outlined]="activeTab !== 'paises'" (click)="activeTab = 'paises'" class="p-button-sm"></button>
    <button pButton [label]="'Departamentos'" [outlined]="activeTab !== 'departamentos'" (click)="activeTab = 'departamentos'" class="p-button-sm"></button>
    <button pButton [label]="'Provincias'" [outlined]="activeTab !== 'provincias'" (click)="activeTab = 'provincias'" class="p-button-sm"></button>
    <button pButton [label]="'Distritos'" [outlined]="activeTab !== 'distritos'" (click)="activeTab = 'distritos'" class="p-button-sm"></button>
  </div>

  <div *ngIf="activeTab === 'paises'">
    <div class="flex justify-content-end mb-3">
      <button pButton label="Nuevo País" icon="pi pi-plus" class="p-button-sm" (click)="openNewPais()"></button>
    </div>
    <p-table [value]="paises" [rows]="10" [paginator]="true" styleClass="p-datatable-sm" [rowHover]="true">
      <ng-template pTemplate="header">
        <tr><th>ID</th><th>Nombre</th><th class="text-center">Estado</th><th class="text-center">Acciones</th></tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr>
          <td>{{ row.id }}</td>
          <td class="font-bold">{{ row.nombre }}</td>
          <td class="text-center">
            <span [class]="'text-xs font-bold px-2 py-1 border-round ' + (row.isActive ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700')">
              {{ row.isActive ? 'ACTIVO' : 'INACTIVO' }}
            </span>
          </td>
          <td class="text-center">
            <button pButton icon="pi pi-pencil" class="p-button-text p-button-rounded" (click)="editPais(row)" pTooltip="Editar"></button>
            <button pButton icon="pi pi-power-off" class="p-button-text p-button-rounded" [ngClass]="row.isActive ? 'text-red-400' : 'text-green-600'" (click)="togglePais(row)" pTooltip="Activar/Desactivar"></button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <div *ngIf="activeTab === 'departamentos'">
      <div class="flex justify-content-end mb-3">
        <button pButton label="Nuevo Departamento" icon="pi pi-plus" class="p-button-sm" (click)="openNewDepto()"></button>
      </div>
      <p-table [value]="departamentos" [rows]="10" [paginator]="true" styleClass="p-datatable-sm" [rowHover]="true">
        <ng-template pTemplate="header">
          <tr><th>ID</th><th>Nombre</th><th>País</th><th class="text-center">Estado</th><th class="text-center">Acciones</th></tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr>
            <td>{{ row.id }}</td>
            <td class="font-bold">{{ row.nombre }}</td>
            <td>{{ row.padreNombre }}</td>
            <td class="text-center">
              <span [class]="'text-xs font-bold px-2 py-1 border-round ' + (row.isActive ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700')">
                {{ row.isActive ? 'ACTIVO' : 'INACTIVO' }}
              </span>
            </td>
            <td class="text-center">
              <button pButton icon="pi pi-pencil" class="p-button-text p-button-rounded" (click)="editDepto(row)" pTooltip="Editar"></button>
              <button pButton icon="pi pi-power-off" class="p-button-text p-button-rounded" [ngClass]="row.isActive ? 'text-red-400' : 'text-green-600'" (click)="toggleDepto(row)" pTooltip="Activar/Desactivar"></button>
            </td>
          </tr>
        </ng-template>
      </p-table>
  </div>

  <div *ngIf="activeTab === 'provincias'">
      <div class="flex justify-content-end mb-3">
        <button pButton label="Nueva Provincia" icon="pi pi-plus" class="p-button-sm" (click)="openNewProv()"></button>
      </div>
      <p-table [value]="provincias" [rows]="10" [paginator]="true" styleClass="p-datatable-sm" [rowHover]="true">
        <ng-template pTemplate="header">
          <tr><th>ID</th><th>Nombre</th><th>Departamento</th><th class="text-center">Estado</th><th class="text-center">Acciones</th></tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr>
            <td>{{ row.id }}</td>
            <td class="font-bold">{{ row.nombre }}</td>
            <td>{{ row.padreNombre }}</td>
            <td class="text-center">
              <span [class]="'text-xs font-bold px-2 py-1 border-round ' + (row.isActive ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700')">
                {{ row.isActive ? 'ACTIVO' : 'INACTIVO' }}
              </span>
            </td>
            <td class="text-center">
              <button pButton icon="pi pi-pencil" class="p-button-text p-button-rounded" (click)="editProv(row)" pTooltip="Editar"></button>
              <button pButton icon="pi pi-power-off" class="p-button-text p-button-rounded" [ngClass]="row.isActive ? 'text-red-400' : 'text-green-600'" (click)="toggleProv(row)" pTooltip="Activar/Desactivar"></button>
            </td>
          </tr>
        </ng-template>
      </p-table>
  </div>

  <div *ngIf="activeTab === 'distritos'">
      <div class="flex justify-content-end mb-3">
        <button pButton label="Nuevo Distrito" icon="pi pi-plus" class="p-button-sm" (click)="openNewDistrito()"></button>
      </div>
      <p-table [value]="distritos" [rows]="10" [paginator]="true" styleClass="p-datatable-sm" [rowHover]="true">
        <ng-template pTemplate="header">
          <tr><th>ID</th><th>Nombre</th><th>Código</th><th>Provincia</th><th class="text-center">Estado</th><th class="text-center">Acciones</th></tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr>
            <td>{{ row.id }}</td>
            <td class="font-bold">{{ row.nombre }}</td>
            <td>{{ row.codigoUbigeo || '—' }}</td>
            <td>{{ row.padreNombre }}</td>
            <td class="text-center">
              <span [class]="'text-xs font-bold px-2 py-1 border-round ' + (row.isActive ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700')">
                {{ row.isActive ? 'ACTIVO' : 'INACTIVO' }}
              </span>
            </td>
            <td class="text-center">
              <button pButton icon="pi pi-pencil" class="p-button-text p-button-rounded" (click)="editDistrito(row)" pTooltip="Editar"></button>
              <button pButton icon="pi pi-power-off" class="p-button-text p-button-rounded" [ngClass]="row.isActive ? 'text-red-400' : 'text-green-600'" (click)="toggleDistrito(row)" pTooltip="Activar/Desactivar"></button>
            </td>
          </tr>
        </ng-template>
      </p-table>
  </div>

  <!-- Diálogos -->
  <p-dialog [(visible)]="dialogPais" header="{{ itemPais.id ? 'Editar País' : 'Nuevo País' }}" [modal]="true" [style]="{width: '400px'}" styleClass="p-fluid">
    <div class="field">
      <label>Nombre</label>
      <input pInputText [(ngModel)]="itemPais.nombre" placeholder="Ej: Perú" />
      <small class="p-error" *ngIf="submitted && !itemPais.nombre">Requerido.</small>
    </div>
    <ng-template pTemplate="footer">
      <button pButton label="Cancelar" class="p-button-text" (click)="dialogPais = false"></button>
      <button pButton label="Guardar" icon="pi pi-check" (click)="savePais()"></button>
    </ng-template>
  </p-dialog>

  <p-dialog [(visible)]="dialogDepto" header="{{ itemDepto.id ? 'Editar Departamento' : 'Nuevo Departamento' }}" [modal]="true" [style]="{width: '400px'}" styleClass="p-fluid">
    <div class="field">
      <label>Nombre</label>
      <input pInputText [(ngModel)]="itemDepto.nombre" placeholder="Ej: Lima" />
      <small class="p-error" *ngIf="submitted && !itemDepto.nombre">Requerido.</small>
    </div>
    <div class="field">
      <label>País</label>
      <p-select [options]="paisesOptions" [(ngModel)]="itemDepto.paisId" optionLabel="nombre" optionValue="id" placeholder="Seleccionar país" styleClass="w-full"></p-select>
      <small class="p-error" *ngIf="submitted && !itemDepto.paisId">Requerido.</small>
    </div>
    <ng-template pTemplate="footer">
      <button pButton label="Cancelar" class="p-button-text" (click)="dialogDepto = false"></button>
      <button pButton label="Guardar" icon="pi pi-check" (click)="saveDepto()"></button>
    </ng-template>
  </p-dialog>

  <p-dialog [(visible)]="dialogProv" header="{{ itemProv.id ? 'Editar Provincia' : 'Nueva Provincia' }}" [modal]="true" [style]="{width: '400px'}" styleClass="p-fluid">
    <div class="field">
      <label>Nombre</label>
      <input pInputText [(ngModel)]="itemProv.nombre" placeholder="Ej: Lima" />
      <small class="p-error" *ngIf="submitted && !itemProv.nombre">Requerido.</small>
    </div>
    <div class="field">
      <label>Departamento</label>
      <p-select [options]="departamentosOptions" [(ngModel)]="itemProv.departamentoId" optionLabel="nombre" optionValue="id" placeholder="Seleccionar departamento" styleClass="w-full"></p-select>
      <small class="p-error" *ngIf="submitted && !itemProv.departamentoId">Requerido.</small>
    </div>
    <ng-template pTemplate="footer">
      <button pButton label="Cancelar" class="p-button-text" (click)="dialogProv = false"></button>
      <button pButton label="Guardar" icon="pi pi-check" (click)="saveProv()"></button>
    </ng-template>
  </p-dialog>

  <p-dialog [(visible)]="dialogDistrito" header="{{ itemDistrito.id ? 'Editar Distrito' : 'Nuevo Distrito' }}" [modal]="true" [style]="{width: '400px'}" styleClass="p-fluid">
    <div class="field">
      <label>Nombre</label>
      <input pInputText [(ngModel)]="itemDistrito.nombre" placeholder="Ej: Miraflores" />
      <small class="p-error" *ngIf="submitted && !itemDistrito.nombre">Requerido.</small>
    </div>
    <div class="field">
      <label>Código Ubigeo (opcional)</label>
      <input pInputText [(ngModel)]="itemDistrito.codigoUbigeo" placeholder="Ej: 150122" />
    </div>
    <div class="field">
      <label>Provincia</label>
      <p-select [options]="provinciasOptions" [(ngModel)]="itemDistrito.provinciaId" optionLabel="nombre" optionValue="id" placeholder="Seleccionar provincia" styleClass="w-full"></p-select>
      <small class="p-error" *ngIf="submitted && !itemDistrito.provinciaId">Requerido.</small>
    </div>
    <ng-template pTemplate="footer">
      <button pButton label="Cancelar" class="p-button-text" (click)="dialogDistrito = false"></button>
      <button pButton label="Guardar" icon="pi pi-check" (click)="saveDistrito()"></button>
    </ng-template>
  </p-dialog>
</div>
